import apiClient from '@u/apiClient'
import FetchItemsDossierByDossierIdController from '@/wayfinder/actions/App/Http/Controllers/Dossier/FetchItemsDossierByDossierIdController'
import FetchItemDossierByIdController from '@/wayfinder/actions/App/Http/Controllers/Dossier/FetchItemDossierByIdController'
import GetItemsDossierForManageStockController from '@/wayfinder/actions/App/Http/Controllers/Dossier/GetItemsDossierForManageStockController'
import AddItemsToDossierController from '@/wayfinder/actions/App/Http/Controllers/Dossier/ItemDossier/AddItemsToDossierController'
import AddEnaosItemToDossierController from '@/wayfinder/actions/App/Http/Controllers/Dossier/ItemDossier/AddEnaosItemToDossierController'
import AddItemsToModelController from '@/wayfinder/actions/App/Http/Controllers/Dossier/ItemDossier/AddItemsToModelController'
import AddWikiItemsToModelController from '@/wayfinder/actions/App/Http/Controllers/Dossier/AddWikiItemsToModelController'
import AddPackToDossierController from '@/wayfinder/actions/App/Http/Controllers/Dossier/ItemDossier/AddPackToDossierController'
import GetItemFromInvoiceableController from '@/wayfinder/actions/App/Http/Controllers/Dossier/GetItemFromInvoiceableController'
import CreateInvoiceForInvoiceableController from '@/wayfinder/actions/App/Http/Controllers/Dossier/CreateInvoiceForInvoiceableController'
import CreateInvoiceForEnaosItemController from '@/wayfinder/actions/App/Http/Controllers/Dossier/CreateInvoiceForEnaosItemController'
import UpdateItemDossierController from '@/wayfinder/actions/App/Http/Controllers/Dossier/ItemDossier/UpdateItemDossierController'
import DeleteItemDossierController from '@/wayfinder/actions/App/Http/Controllers/Dossier/ItemDossier/DeleteItemDossierController'
import DeleteItemModelController from '@/wayfinder/actions/App/Http/Controllers/Dossier/ItemDossier/DeleteItemModelController'
import GetStockableDossierItemsController from '@/wayfinder/actions/App/Http/Controllers/Dossier/GetStockableDossierItemsController'
import RenderItemDossierController from '@/wayfinder/actions/App/Http/Controllers/Dossier/ItemDossier/RenderItemDossierController'

function processSuccessCallback(payload) {
  if (payload.successCallback) {
    payload.successCallback()
  }
}

export default {
  async fetchItemsDossier({ commit }, payload) {
    await apiClient
      .route(
        FetchItemsDossierByDossierIdController[
          '/api/dossier/fetch-items-dossier/{dossier}'
        ].get({ dossier: payload.dossier_id })
      )
      .then(async (response) => {
        if (response.status === 200) {
          commit('setDossierItems', response.data.items)
          processSuccessCallback(payload)
        }
      })
      .catch(async (reason) => {
        await console.error('addItemsToDossier', reason)
      })
  },
  fetchItemsDossierByCategory({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          FetchItemsDossierByDossierIdController[
            '/api/dossier/fetch-items-dossier/{dossier}'
          ].get({ dossier: payload.dossier_id }),
          {
            params: {
              category_ids: payload.category_ids,
              ...(payload.only_with_tasks ? { only_with_tasks: 1 } : {})
            }
          }
        )
        .then((response) => {
          resolve(response.data.items)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  fetchItemDossierById({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          FetchItemDossierByIdController.get({
            dossier: payload.dossier_id,
            item_dossier: payload.item_dossier_id
          })
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  async fetchItemsDossierForManageStock({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          GetItemsDossierForManageStockController.get({
            dossier: payload.dossier_id
          })
        )
        .then(async (response) => {
          resolve(response.data)
        })
        .catch(async (reason) => {
          await console.error('fetchItemsDossierForManageStock', reject(reason))
        })
    })
  },
  async addItemsToDossier({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          AddItemsToDossierController.post({ dossier: payload.id }),
          payload.data
        )
        .then(async (response) => {
          resolve(response.data)
        })
        .catch(async (reason) => {
          reject(reason)
        })
    })
  },
  async addEnaosItemToDossier({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          AddEnaosItemToDossierController.post({ dossier: payload.id }),
          payload.data
        )
        .then(async (response) => {
          resolve(response.data)
        })
        .catch(async (reason) => {
          reject(reason)
        })
    })
  },
  async addItemsToModel({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          AddItemsToModelController.post({
            dossier: payload.dossierId,
            model: payload.id
          }),
          payload.data
        )
        .then(async (response) => {
          resolve(response.data)
        })
        .catch(async (reason) => {
          reject(reason)
        })
    })
  },
  async addWikiItemsToModel({ commit }, payload) {
    return new Promise((resolve, reject) => {
      const { modelType, modelId, items } = payload
      apiClient
        .route(
          AddWikiItemsToModelController.post({ modelType, modelId }),
          items
        )
        .then(async (response) => {
          if (modelType === 'event' && response.data?.items) {
            commit('setEventItemsByEventId', {
              eventId: modelId,
              items: response.data.items
            })
          }
          resolve(response.data)
        })
        .catch(async (reason) => {
          reject(reason)
        })
    })
  },
  async addPacksToDossier({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          AddPackToDossierController.post({ dossier: payload.id }),
          payload.data
        )
        .then(async (response) => {
          resolve(response.data)
        })
        .catch(async (reason) => {
          reject(reason)
        })
    })
  },
  getItemFromInvoiceableController({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          GetItemFromInvoiceableController.get({
            dossier: payload.dossier_id,
            person: payload.person_id
          })
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  storeNewInvoiceForInvoiceable({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          CreateInvoiceForInvoiceableController.post({
            dossier: payload.dossier_id,
            person: payload.person_id
          }),
          payload.params
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  storeNewInvoiceForEnaosItem({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          CreateInvoiceForEnaosItemController.post({
            dossier: payload.dossier_id
          }),
          payload.params
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => {
          console.error('Erreur storeNewInvoiceForEnaosItem:', error)
          reject(error)
        })
    })
  },
  updateItemDossier({ commit }, payload) {
    commit('auth/setErrors', {}, { root: true })
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          UpdateItemDossierController.put({
            dossier: payload.dossier_id,
            itemDossier: payload.item_dossier_id
          }),
          payload.item_dossier
        )
        .then((response) => {
          // commit('setDossier', response.data.dossier)
          // commit('setDossierMetadata', response.data.metadata)
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  deleteItemDossier({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          DeleteItemDossierController.delete({
            dossier: payload.dossier_id,
            itemDossier: payload.item_dossier_id
          })
        )
        .then((response) => {
          // commit('setDossier', response.data.dossier)
          // commit('setDossierMetadata', response.data.metadata)
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  deleteItemModel({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          DeleteItemModelController.delete({
            dossier: payload.dossierId,
            model_id: payload.model_id,
            itemDossier: payload.item_dossier_id
          }),
          {
            data: {
              model_type: payload.model_type
            }
          }
        )
        .then((response) => {
          commit('setDossier', response.data.dossier)
          commit('setDossierMetadata', response.data.metadata)
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  fetchItemsDossierStockable({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          GetStockableDossierItemsController.get({
            dossier: payload.dossier_id
          })
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  exportItemDossierPDF: ({ commit }, payload) => {
    console.log('rigth action')
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          RenderItemDossierController.get({
            dossier: payload.dossier_id,
            itemDossier: payload.item_dossier_id
          })
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  }
}
